
import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface FormButtonsProps {
  isSubmitting: boolean;
  submitButtonText: string;
  hasErrors: boolean;
  errorMessage?: string;
}

export function FormButtons({
  isSubmitting,
  submitButtonText,
  hasErrors,
  errorMessage,
}: FormButtonsProps) {
  return (
    <div className="space-y-4">
      {hasErrors && (
        <Alert variant="destructive">
          <AlertDescription>
            Please fix the errors in the form before submitting.
          </AlertDescription>
        </Alert>
      )}
      
      {errorMessage && (
        <Alert variant="destructive">
          <AlertDescription>{errorMessage}</AlertDescription>
        </Alert>
      )}
      
      <div className="flex justify-end">
        <Button 
          type="submit" 
          disabled={isSubmitting || hasErrors}
          className="w-full md:w-auto"
        >
          {isSubmitting ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Processing...
            </>
          ) : (
            submitButtonText
          )}
        </Button>
      </div>
    </div>
  );
}
